import omit from "lodash/omit";

import dataProvider from "./dataProvider";
import paramConstants from "../constants/paramConstants";

const isResourceImageData = (resource, data) =>
  !(
    !paramConstants.resourcesWithImageParams.includes(resource) ||
    !paramConstants.imageParamKeys.find(
      key => key in data && typeof data[key] !== "string" && data[key] !== null
    )
  );

const getKeysToDropAndShouldUsePatch = (imageParamKeys, params) => {
  const keysToDrop = [];
  let shouldUsePatch = false;
  imageParamKeys.forEach(key => {
    const { data } = params;
    const isImageParamWithNoFile = key in data && typeof data[key] === "string";
    const isImageParamNull = data[key] === null;
    if (isImageParamWithNoFile || isImageParamNull) {
      keysToDrop.push(key);
    }
    shouldUsePatch = isImageParamWithNoFile || shouldUsePatch;
  });
  return { keysToDrop, shouldUsePatch };
};

const getFormData = object =>
  Object.keys(object).reduce((formData, key) => {
    if (paramConstants.imageParamKeys.includes(key) && object[key]) {
      formData.append(key, object[key].rawFile);
    } else if (object[key] !== null) {
      // eslint-disable-next-line no-unused-expressions
      Array.isArray(object[key])
        ? formData.append(key, JSON.stringify(object[key]))
        : formData.append(key, object[key]);
    }
    return formData;
  }, new FormData());

const fileDataProvider = {
  ...dataProvider,
  create: (resource, params) => {
    if (Array.isArray(params.data)) {
      // For orderable APIs as the expect array of dic in data
      return dataProvider.create(resource, params);
    }
    if (!isResourceImageData(resource, params.data)) {
      // fallback to the default implementation
      const { keysToDrop } = getKeysToDropAndShouldUsePatch(
        paramConstants.imageParamKeys,
        params
      );
      const omittedParams = {
        ...params,
        data: omit(params.data, keysToDrop),
      };
      return dataProvider.create(resource, omittedParams);
    }
    return dataProvider.create(
      resource,
      params,
      getFormData({ ...params.data })
    );
  },
  update: (resource, params) => {
    if (!isResourceImageData(resource, params.data)) {
      // fallback to the default implementation
      const { keysToDrop, shouldUsePatch } = getKeysToDropAndShouldUsePatch(
        paramConstants.imageParamKeys,
        params
      );
      const omittedParams = {
        ...params,
        data: omit(params.data, keysToDrop),
      };
      if (shouldUsePatch) {
        return dataProvider.updatePatch(resource, omittedParams);
      }
      return dataProvider.update(resource, omittedParams);
    }
    return dataProvider.update(
      resource,
      params,
      getFormData({ ...params.data })
    );
  },
};

export default fileDataProvider;
